import loadableWithRetry from '../common/loadableWithRetry'

const NewsLetterForm = loadableWithRetry(() => import('./NewsLetterForm'));

export default NewsLetterForm;
